<template>
  <FlexTable class="portions-table">
    <div class="flex-th table-title">
      Porciones
      <div class="portions-btnbar-group">
        <b-button @click="isExpanded = !isExpanded" variant="light" size="sm" id="expand-button">
          <i v-if="isExpanded" class="wizard-icon ti-arrow-right" />
          <i class="wizard-icon ti-arrow-left" />
          <i v-if="!isExpanded" class="wizard-icon ti-arrow-right" />
        </b-button>
        <b-tooltip
            target="expand-button"
            triggers="hover"
            placement="left"
          >{{isExpanded ? "Ocultar" : "Mostrar"}} datos de 1 porción</b-tooltip>
      </div>
    </div>
    <div class="flex-trow flex-trow-header">
      <div class="flex-th details-th">Alimento</div>
      <transition name="fade"><div v-if="isExpanded" class="flex-th">Calorías</div></transition>
      <transition name="fade"><div v-if="isExpanded" class="flex-th">H. de C.</div></transition>
      <transition name="fade"><div v-if="isExpanded" class="flex-th">Lípidos</div></transition>
      <transition name="fade"><div v-if="isExpanded" class="flex-th">Proteínas</div></transition>
      <div class="flex-th">Porciones</div>
      <div class="flex-th">Calorías</div>
      <div class="flex-th">H. de C</div>
      <div class="flex-th">Lípidos</div>
      <div class="flex-th">Proteínas</div>
    </div>
    <PortionsTableRow 
      v-for="(food, index) in formData" 
      :key="food.food_group.id" 
      v-model="formData[index]"
      :is-expanded="isExpanded"
      @recalculate-totals="recalculateTotals"
    />    
    <div class="flex-trow flex-trow-header">
      <div class="flex-th details-th"></div>
      <transition name="fade"><div v-if="isExpanded" class="flex-th"></div></transition>
      <transition name="fade"><div v-if="isExpanded" class="flex-th"></div></transition>
      <transition name="fade"><div v-if="isExpanded" class="flex-th"></div></transition>
      <transition name="fade"><div v-if="isExpanded" class="flex-th"></div></transition>
      <div class="flex-th"> Total </div>
      <div class="flex-th"> {{totalCalories}} </div>
      <div class="flex-th"> {{totalCho}} </div>
      <div class="flex-th"> {{totalLipid}} </div>
      <div class="flex-th"> {{totalProtein}} </div>
    </div>
    <div class="flex-trow flex-trow-header">
      <div class="flex-th details-th"></div>
      <transition name="fade"><div v-if="isExpanded" class="flex-th"></div></transition>
      <transition name="fade"><div v-if="isExpanded" class="flex-th"></div></transition>
      <transition name="fade"><div v-if="isExpanded" class="flex-th"></div></transition>
      <transition name="fade"><div v-if="isExpanded" class="flex-th"></div></transition>
      <div class="flex-th"> Req </div>
      <div class="flex-th"> {{requirements}} </div>
      <div class="flex-th"> {{choGrams}} </div>
      <div class="flex-th"> {{lipidGrams}} </div>
      <div class="flex-th"> {{proteinGrams}} </div>
    </div>
    <div class="flex-trow flex-trow-header">
      <div class="flex-th details-th"></div>
      <transition name="fade"><div v-if="isExpanded" class="flex-th"></div></transition>
      <transition name="fade"><div v-if="isExpanded" class="flex-th"></div></transition>
      <transition name="fade"><div v-if="isExpanded" class="flex-th"></div></transition>
      <transition name="fade"><div v-if="isExpanded" class="flex-th"></div></transition>
      <div class="flex-th"> % Adec </div>
      <div class="flex-th"> {{adequacyCalories}}% </div>
      <div class="flex-th"> {{adequacyCho}}% </div>
      <div class="flex-th"> {{adequacyLipid}}% </div>
      <div class="flex-th"> {{adequacyProtein}}% </div>
    </div>
  </FlexTable>
</template>

<script>
import FlexTable from "./base/FlexTable";
import EditableCellInput from "../EditableCellInput";
import EditableCellSelect from '../EditableCellSelect';
import { decimal, required } from 'vuelidate/lib/validators';
import ThemifyIcon from '@icon/themify-icons/themify-icons.css';
import PortionsTableRow from './PortionsTableRow';

export default {
  name: "PortionsTable",
  components: { 
    EditableCellSelect, 
    EditableCellInput, 
    FlexTable, 
    ThemifyIcon,
    PortionsTableRow
  },
  model: {
    prop: "dietData",
    event: "change",
  },
  props: { 
    dietData: {
      type: Array,
      default: function () {
        return []
      },
    },
    requirements: [Number, String],
    choGrams: [Number, String],
    lipidGrams: [Number, String],
    proteinGrams: [Number, String]
  },
  data: function() {
    return {
      formData: this.dietData,
      isExpanded: false,
      totalCalories: 0,
      totalCho: 0,
      totalLipid: 0,
      totalProtein: 0
    }
  },
  validations: {
    formData: { 
      $each: {
        quantity: {
          decimal,
          required
        }
      }
    }
  },
  computed: {
    adequacyCalories: function () {
      let requirement = this.requirements
      let calories = this.totalCalories
      if (isNaN(requirement) || isNaN(calories)) {
        return "--"
      } else {
        return ((calories * 100 ) / requirement).toFixed(0)
      }
    },
    adequacyCho: function () {
      let requirement = this.choGrams
      let cho = this.totalCho
      if (isNaN(requirement) || isNaN(cho)) {
        return "--"
      } else {
        return ((Number(cho) * 100 ) / Number(requirement)).toFixed(0)
      }
    },
    adequacyLipid: function () {
      let requirement = this.lipidGrams
      let lipid = this.totalLipid
      if (isNaN(requirement) || isNaN(lipid)) {
        return "--"
      } else {
        return ((lipid * 100 ) / requirement).toFixed(0)
      }
    },
    adequacyProtein: function () {
      let requirement = this.proteinGrams
      let protein = this.totalProtein
      if (isNaN(requirement) || isNaN(protein)) {
        return "--"
      } else {
        return ((protein * 100 ) / requirement).toFixed(0)
      }
    }
  },
  watch: {
    formData: {
      handler: function(val) {
        this.$emit("change", val)
      },
    },
    dietData: function(val) {
      this.formData = val
    },
  },
  methods: {
    getTotals: function () {
      let foods = this.formData
      let calorieCount = 0
      let choCount = 0
      let proteinCount = 0
      let lipidCount = 0
      if (foods) {
        for (const food of foods) {
          let calories = food.portionsCalories
          let choGrams = food.portionsCHO
          let proteinGrams = food.portionsProtein
          let lipidGrams = food.portionsLipid
          if (isNaN(calories)) {
            calories = 0
          } 
          if (isNaN(choGrams)) {
            choGrams = 0
          } 
          if (isNaN(lipidGrams)) {
            lipidGrams = 0
          } 
          if (isNaN(proteinGrams)) {
            proteinGrams = 0
          } 
          calorieCount = Number(calorieCount) + Number(calories)
          choCount = Number(choCount) + Number(choGrams)
          proteinCount = Number(proteinCount) + Number(proteinGrams)
          lipidCount = Number(lipidCount) + Number(lipidGrams)
        }
        return {
          calories: calorieCount, 
          cho: choCount, 
          protein: proteinCount, 
          lipid: lipidCount
          }
      } else {
        return {
          calories: "--", 
          cho: "--", 
          protein: "--", 
          lipid: "--"
          }
      }
    },
    recalculateTotals: function () {
      let totals = this.getTotals()
      this.totalCalories = totals.calories
      this.totalCho = totals.cho
      this.totalLipid = totals.lipid
      this.totalProtein = totals.protein
      this.$emit('update-totals', totals)
    },
    validate() {
      this.$v.formData.$touch();
      var isValid = !this.$v.formData.$invalid
      this.$emit('on-validate', isValid)
      return isValid
    }
  }
}
</script>

<style scoped lang="scss">
$portions-table-base-color: #517a51;
$portions-table-title-bg-color: $portions-table-base-color;
$portions-table-title-color: $white;
$portions-table-header-bg-color: rgba($portions-table-base-color, 0.1);
$portions-table-header-color: darken($portions-table-base-color, 25);

.portions-table {
  overflow-x: auto;
  padding: 4px;
  width: 100%;
  flex-direction: column;
  margin-bottom: 1rem;
}

.flex-th.table-title {
  background-color: $portions-table-title-bg-color;
  color: white;
  position: sticky;
  left: 0;
  width: 100%;
}

.flex-th {
  background-color: $portions-table-header-bg-color;
  color: $portions-table-header-color;
  padding: 0.25rem;
}

.flex-trow-content > .flex-td {
  flex: 1 0 6rem;
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
}

.flex-trow-content > .aditional-info {
  background-color: rgba($portions-table-base-color, 0.03);
}

.flex-trow-header > .flex-th {
  flex: 1 0 6rem;
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
}

.flex-trow-header > .flex-th.num-cell, .flex-trow-content > .flex-td.num-cell {
  flex: 1 0 6rem;
}

.flex-trow-header > .flex-th.details-th, .flex-trow-content > .flex-td.details-td {
  flex: 1 0 12rem;
}

.with-unit {
  position: relative;

  & input {
    padding-top: 0;
    padding-bottom: 1rem;
  }

  & select {
    display: block;
    color: $gray-500;
    font-size: $font-size-sm;
    position: absolute;
    top: 50%;
    line-height: 1.3em;

    &:hover:not([disabled]) {
      color: $body-color;
    }

    &:hover[disabled] {
      background-color: transparent;
      cursor: unset;
    }

    &:active, &:focus {
      color: $body-color;
      background-color: $active-background-color;
    }
  }
}

.portions-btnbar-group {
  position: absolute;
  right: 0.5rem;
  display: flex;
  align-items: center;

  & button {
    margin: 0 map_get($spacers, 1);
    width: 2.5rem;
    height: 1.5rem;
    padding: 0.2rem 0.2rem 0.2rem;
    line-height: 0;
    font-weight: bold;
  }
}

.fade-enter-active {
  transition: all 1s;
}
.fade-leave-active {
  transition: all .4s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  width: 0;
}

// Hide incremental arrows
/* Chrome, Safari, Edge, Opera */
.editable-cell input::-webkit-outer-spin-button,
.editable-cell input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.editable-cell input[type=number] {
  -moz-appearance: textfield;
}
</style>